module.exports = __webpack_public_path__ + "b59ef55cc6784a8ed81efd3b9393ca78.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/mp.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/mp.svg
// module chunks = 0